<template>
    <a class="btn-annotation btn-show-resource"
       href="#"
       :style="data.styleRect"
       @click.prevent="showResource"
       :id="`btn-show-resource-${props.pagenum}-${props.btnId}`"
       v-show="isShowAnnot(props.annot.t)"
       ref="refBtn"
    >
        <img :src="`${bookInfoState.publicPath}/${props.annot.iconSrc}`"
             v-if="props.annot.iconSrc"
        >
    </a>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {usePlayBlockControl} from "@/modules/reader/karaoke/playBlockControl";
    import {useMuteRoleControl} from "@/modules/reader/karaoke/muteRoleControl";
    import {useKaraokeControl} from "@/modules/reader/karaoke/karaokeControl";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import {updateFileNameIfMultipleSpeech, appendAccessToken, isFileExist, replaceAudioPathForStagingServer} from  "@/modules/utils/pathUtils";
    import cssvar from "@/scss/_variables.scss";

    let timer;
    const colorRect = cssvar.colorRect;
    const {getResizedAnnotationPos, styleAnnotationBtn, isShowAnnot} = useAnnotationHelper();
    let el;

    export default {

        props: {
          annot:Object,
          pagenum:Number,
          btnId:Number
        },
        setup(props, context) {

            const { parserState, readData} = useParser();
            const { bookInfoState, setPopupHtmlData, setPopupImgaeData, setActiveVideoData,removeActiveVideoData, removeAllMedia,  setActiveAudioSrc, removeActiveAudioSrc} = useBookInfo();
            const { pageResizeState} = usePageResize();
            const refBtn = ref(null)

            const data = reactive({
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    return {
                        ...getResizedAnnotationPos(domPos),
                        //do not scale if the button is transparent, e.g. prichi_6au2tb @p.43-44 , prichi_6au3tb @p66-68, prichi_6au1tb @p.21-22
                        ...styleAnnotationBtn(props.annot.hide, props.annot.iconSrc === undefined),
                    }
                })
            });

            const updateVideoData = (url)=> {

                //removeActiveVideoData();
                removeAllMedia();

                nextTick(()=> {

                    //if no target area, it will be popup video display
                    if (!props.annot.targetRectId) {
                        setActiveVideoData({
                            src: url,
                            type: 'popup',
                            pagenum: props.pagenum
                        })
                        //otherwise, inline display
                    } else {
                        setActiveVideoData({
                            src: url,
                            type: 'inline',
                            targetRectId: props.annot.targetRectId,
                            pagenum: props.pagenum
                        })
                    }
                });
            }

            //TODO: use config..clean codes...
            const showResource= async (e)=> {

                if (props.annot.type === "officedoc" || props.annot.type === "zip") {
                    let path = appendAccessToken(`${bookInfoState.ebookDownloadPath}/${props.annot.url}`);
                    window.open(path, "_blank");
                }
                else if (props.annot.type === "video") {
                    let url;
                    //Not to append multi speech abbreviation to mp4 filename if just one video file for both speeches
                    url = updateFileNameIfMultipleSpeech(`${bookInfoState.publicPath}/${props.annot.url}`);
                    if (isFileExist(url)) {
                        updateVideoData(url);
                    } else {
                        url = `${bookInfoState.publicPath}/${props.annot.url}`;
                        updateVideoData(url);
                    }


                } else if (props.annot.type === "audio") {
                    let url;
                    //Not to append multi speech abbreviation to mp3 filename if just one video file for both speeches
                    url = updateFileNameIfMultipleSpeech(`${bookInfoState.publicPath}/${props.annot.url}`);
                    usePlayBlockControl().reset();
                    useMuteRoleControl().reset();
                    useKaraokeControl().reset();
                    if (isFileExist(url)) {
                        //if served on staging (.23), update url to make 206 response available...
                        url = replaceAudioPathForStagingServer(url);
                        setActiveAudioSrc(url);
                    } else {
                        url = `${bookInfoState.publicPath}/${props.annot.url}`;
                        //if served on staging (.23), update url to make 206 response available...
                        url = replaceAudioPathForStagingServer(url);
                        setActiveAudioSrc(url);
                    }

                } else if (props.annot.type === "image") {
                    if (props.annot.showmode === "popup") {
                        setPopupImgaeData(props.annot.url, {
                            width: props.annot.width,
                            height:props.annot.height
                        })
                    } else {
                         window.open(`${bookInfoState.publicPath}/${props.annot.url}`, "_blank");
                    }
                }  else if (props.annot.type === "html-internal" || props.annot.type === "html-external") {

                    let url;
                    if (props.annot.type === "html-internal") {

                        if ( props.annot.url.indexOf("dict/") >= 0 &&  props.annot.url.indexOf("semester") >=0  &&  props.annot.url.indexOf("unit") >=0  &&   props.annot.url.indexOf("lesson") >=0  &&  props.annot.url.indexOf("words") >= 0) {
                            let query = props.annot.url.split("index.html?")[1];
                            url =  `${process.env.VUE_APP_SW_LINK}?${query}`;
                        } else {
                            url = `${bookInfoState.publicPath}/${props.annot.url}`
                        }

                    } else if (props.annot.type === "html-external"){
                       url =  props.annot.url;
                    }

                    if (props.annot.needAccessToken) {
                        url = appendAccessToken(url)
                    }

                    if (props.annot.showmode === "popup") {
                        setPopupHtmlData(url, {
                            width: props.annot.width,
                            height: props.annot.height
                        })
                    } else {
                        window.open(url, "_blank");
                    }
                } else if (props.annot.type === "glossary") {

                    bookInfoState.isLoadingGlossary = true;
                    bookInfoState.activeGlossaryData = {
                        ...{
                            path:`${bookInfoState.publicPath}/${props.annot.url}`,
                            el: refBtn.value,
                            isShow:true,
                            pagenum:props.pagenum
                        },
                        ...getBtnSizePos(refBtn.value)
                    }

                    console.log("btn pos: ")
                    console.log(bookInfoState.activeGlossaryData.btnPos)
                    console.log("bounding rect: ")
                    console.log(bookInfoState.activeGlossaryData.btnBoundingRect)
                }
            }

            watchEffect(()=>{

                if (bookInfoState.activeGlossaryData && props.annot.type === "glossary") {
                    if (refBtn.value && bookInfoState.activeGlossaryData.el.id === refBtn.value.id) {
                        window.addEventListener("resize", winOnResize)
                    }

                }
            })

            const winOnResize = ()=>{
                clearTimeout(timer)
                if (bookInfoState.activeGlossaryData) {
                    bookInfoState.activeGlossaryData.isShow = false;
                    timer = setTimeout(()=>{
                    if (refBtn.value.id === bookInfoState.activeGlossaryData.el.id) {
                        let updatedSizePos = getBtnSizePos(bookInfoState.activeGlossaryData.el);
                        bookInfoState.activeGlossaryData.isShow = true;
                        bookInfoState.activeGlossaryData.btnPos = updatedSizePos.btnPos;
                        bookInfoState.activeGlossaryData.btnBoundingRect = updatedSizePos.btnBoundingRect;

                    }
                    }, 250)
                }

            }

            /**
             * Used for glossary
             */
            const getBtnSizePos = (el)=>{

                let boundingRect = el.getBoundingClientRect();
                let domPos = getResizedAnnotationPos(props.annot.domPos);

                for (let [key, value] of Object.entries(boundingRect)) {
                    boundingRect[key] = Math.round(value);
                }

                for (let [key, value] of Object.entries(domPos)) {
                    domPos[key] = parseInt(value);
                }

                return  {
                    btnPos:domPos,
                    btnBoundingRect:boundingRect
                }
            }

            return {
                props,
                data,
                refBtn,
                showResource,
                pageResizeState,
                bookInfoState,
                parserState,
                setActiveVideoData,
                setPopupHtmlData,
                setPopupImgaeData,
                setActiveAudioSrc,
                removeActiveAudioSrc,
                getResizedAnnotationPos,
                isShowAnnot
            }

        }
    }

 </script>


<style scoped lang="scss">


</style>